import {Component, OnInit} from '@angular/core';
import {
  Photo,
  PhotoGallerySettings
} from '../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import {
  Animal,
  Rarity,
  Entry,
  Entries
} from '../../../widgets-module/components/animal-rarities/animal-rarities-classes';
import {TripEntry} from '../../../widgets-module/components/trip-list/trip-list.component';
import {SerengetiText} from "./serengeti.text";
import {GoogleMapStyles, Park, Point} from "../../../../google-maps-points";

@Component({
  selector: 'app-serengeti',
  templateUrl: './serengeti.component.html',
  styleUrls: ['./serengeti.component.css']
})
export class SerengetiComponent implements OnInit {

  mobile = false;
  parkText = new SerengetiText();

  tripEntries: TripEntry[] = [
    new TripEntry({title: 'Big Buck', route: '../../safari/big-buck-safari', iconName: 'buffalo'}),
    new TripEntry({title: 'Lion\'s Share', route: '../../safari/lions-share-safari', iconName: 'lion'})
  ];

  // Animal Rarity Tooltips
  animalEntries: Entries = new Entries({
    entries:
      [
        new Entry({animal: Animal.Lion, rarity: Rarity.Common}),
        new Entry({animal: Animal.Elephant, rarity: Rarity.Common}),
        new Entry({animal: Animal.Baboon, rarity: Rarity.Common}),
        new Entry({animal: Animal.Giraffe, rarity: Rarity.Common}),
        new Entry({animal: Animal.Cheetah, rarity: Rarity.Common}),
        new Entry({animal: Animal.Warthog, rarity: Rarity.Common}),
        new Entry({animal: Animal.Zebra, rarity: Rarity.Common}),
        new Entry({animal: Animal.Jackal, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.EgyptianDuck, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.BlackRhino, rarity: Rarity.Rare})
      ]
  });

  // photo gallery metadata
  lionPhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Lion on the Prowl',
          description: 'The female lion is slunk down low, ready to engage, and is moving rapidly towards the pack of Thomson\'s Gazelle!',
          thumbnailPath: '700x525/lion-on-the-prowl.jpg',
          highresPath: '../../assets/img/others/lion-on-the-prowl.jpg',
          altPhotoDescription: 'Female Lion hunting Thompson Gazelle!'
        })
      ]
  });
  cheetahPhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Cheetah and her Cubs',
          description: 'Mother Cheetah and her two cubs wake up from an afternoon nap, under the Serengeti Sun.',
          thumbnailPath: '600x400/cheetah-and-cubs.jpg',
          highresPath: '../../assets/img/others/cheetah-and-cubs.jpg',
          altPhotoDescription: 'Yawning cheetah mom and her cubs'
        })
      ]
  });
  oxpeckerPhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Friends with Benefits',
          description: 'An Oxpecker Bird rests on the horns of an African Buffalo. <br/><br/>' +
            'Oxpeckers are known for their fluorescent colored beaks. ' +
            'They graze on insects, wounds, and specks of dirt which have collected on the buffalo.',
          thumbnailPath: '600x400/oxpecker-on-a-buffalo.jpg',
          highresPath: '../../assets/img/others/oxpecker-on-a-buffalo.jpg',
          altPhotoDescription: 'Oxpecker Bird on an African Buffalo'
        })
      ]
  });

  mapLat = -2.1349733;
  mapLng = 34.35218811;
  googleMapStyles = GoogleMapStyles;

  circleWidthsDesktop = ['3rem', '3.25rem', '5rem', '5rem'];
  circleWidthsMobile = ['3.5rem', '3.75rem', '6.25rem', '6.5rem'];

  parkBoundaries = [
    new Park({
      name: 'Serengeti National Park',
      contentId: '/national-parks/serengeti',
      defaultColor: '#E14658',
      hoverColor: '#A43341',
      tooltipOrigin: new Point({lng: 34.35218811, lat: -2.1349733}),
      points:
        [
          new Point({lng: 34.88142014, lat: -3.20444767}),
          new Point({lng: 34.88227844, lat: -2.87583639}),
          new Point({lng: 34.99300003, lat: -2.98504168}),
          new Point({lng: 34.9864769, lat: -2.99361307}),
          new Point({lng: 34.98613358, lat: -3.01212704}),
          new Point({lng: 35.01600266, lat: -3.02241245}),
          new Point({lng: 35.00741959, lat: -2.97852738}),
          new Point({lng: 35.12346268, lat: -2.9214399}),
          new Point({lng: 35.1389122, lat: -2.91081067}),
          new Point({lng: 35.21959305, lat: -2.50305628}),
          new Point({lng: 35.16122818, lat: -2.39449387}),
          new Point({lng: 35.26611328, lat: -2.35933356}),
          new Point({lng: 35.2664566, lat: -2.30444741}),
          new Point({lng: 35.23452759, lat: -2.16567904}),
          new Point({lng: 35.20998001, lat: -2.07184448}),
          new Point({lng: 35.25718689, lat: -1.68770221}),
          new Point({lng: 34.78134155, lat: -1.41983757}),
          new Point({lng: 34.71096039, lat: -1.46548502}),
          new Point({lng: 34.70031738, lat: -1.48710717}),
          new Point({lng: 34.69894409, lat: -1.50838591}),
          new Point({lng: 34.69894409, lat: -1.54124743}),
          new Point({lng: 34.69345093, lat: -1.55437473}),
          new Point({lng: 34.68366623, lat: -1.55763509}),
          new Point({lng: 34.67679977, lat: -1.56364101}),
          new Point({lng: 34.66109276, lat: -1.55935107}),
          new Point({lng: 34.65023518, lat: -1.57346494}),
          new Point({lng: 34.64534283, lat: -1.57080519}),
          new Point({lng: 34.64362621, lat: -1.57363654}),
          new Point({lng: 34.6463728, lat: -1.57689687}),
          new Point({lng: 34.64585781, lat: -1.58084359}),
          new Point({lng: 34.64208126, lat: -1.58530508}),
          new Point({lng: 34.64281082, lat: -1.59161121}),
          new Point({lng: 34.70409393, lat: -1.65930437}),
          new Point({lng: 34.7171402, lat: -1.66565317}),
          new Point({lng: 34.74597931, lat: -1.71464117}),
          new Point({lng: 34.76297379, lat: -1.71721493}),
          new Point({lng: 34.77172852, lat: -1.7261373}),
          new Point({lng: 34.78683472, lat: -1.74809985}),
          new Point({lng: 34.78855133, lat: -1.75564942}),
          new Point({lng: 34.79619026, lat: -1.76920426}),
          new Point({lng: 34.81181145, lat: -1.78636213}),
          new Point({lng: 34.82992172, lat: -1.82436625}),
          new Point({lng: 34.83026505, lat: -1.83140079}),
          new Point({lng: 34.81953621, lat: -1.85490623}),
          new Point({lng: 34.85798836, lat: -2.01746247}),
          new Point({lng: 34.8035717, lat: -2.19063773}),
          new Point({lng: 34.62882042, lat: -2.17674325}),
          new Point({lng: 34.52590942, lat: -2.21919819}),
          new Point({lng: 34.55234528, lat: -2.17151135}),
          new Point({lng: 34.40574646, lat: -2.15744516}),
          new Point({lng: 34.25253868, lat: -2.08591145}),
          new Point({lng: 34.21460152, lat: -2.08556835}),
          new Point({lng: 34.14173126, lat: -2.0932022}),
          new Point({lng: 34.10345078, lat: -2.09045745}),
          new Point({lng: 33.96260262, lat: -2.06438207}),
          new Point({lng: 33.87007713, lat: -2.09920633}),
          new Point({lng: 33.86810303, lat: -2.10804093}),
          new Point({lng: 33.87256622, lat: -2.11936288}),
          new Point({lng: 33.869133, lat: -2.18214668}),
          new Point({lng: 33.87153625, lat: -2.19415421}),
          new Point({lng: 33.86569977, lat: -2.20273096}),
          new Point({lng: 33.98620605, lat: -2.21336607}),
          new Point({lng: 34.01968002, lat: -2.27683202}),
          new Point({lng: 34.27528381, lat: -2.42176392}),
          new Point({lng: 34.33467865, lat: -2.58434359}),
          new Point({lng: 34.53929901, lat: -2.81651483}),
          new Point({lng: 34.66873169, lat: -3.00749858})
        ]
    })
  ];

  constructor() {
  }

  ngOnInit() {
  }

  isMobile() {
    return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
  }

  isMobileBr() {
    return document.body.clientWidth < 500;
  }

}
